import Cookies from 'js-cookie'
const DEFAULT_EXPIRES = 365 // 1 year (365 days)

// default settings for cookies
Cookies.defaults = { expires: DEFAULT_EXPIRES, path: '/' }
export default Cookies
